/**
 * Page Charte de Partenariat - FTPE Outremer
 */
import React from 'react';
import { FileText, CheckCircle, Shield, Scale, Users, Handshake } from 'lucide-react';
import BackButton from '../components/BackButton';

// Logo FTPE Outremer
const FTPE_LOGO = "https://customer-assets.emergentagent.com/job_80d9c916-7281-4428-9c84-a6e0cd256c92/artifacts/ojac2aim_logo%20ftpe%20outremer%20dans%20fond%20blanc.png";

export default function FTPEChartePage() {
  const principes = [
    { icon: Scale, text: "Indépendance et neutralité" },
    { icon: Users, text: "Absence de confusion des rôles" },
    { icon: Shield, text: "Éthique et transparence" },
    { icon: Handshake, text: "Intérêt collectif des TPE ultramarines" }
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-900 via-green-900 to-slate-900 text-white py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6">
            <BackButton variant="dark" label="Retour" />
          </div>
          
          <div className="flex items-center gap-6">
            <img src={FTPE_LOGO} alt="FTPE Outremer" className="w-16 h-16 object-contain rounded-lg bg-white p-2" />
            <div>
              <h1 className="text-3xl md:text-4xl font-bold mb-2">
                Charte de <span className="text-amber-400">partenariat</span>
              </h1>
              <p className="text-slate-300">FTPE Outremer – Syndicat patronal des TPE ultramarines</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <div className="max-w-4xl mx-auto bg-white shadow-lg -mt-8 relative z-10 rounded-2xl p-8 md:p-12 mb-12">
        
        {/* Préambule */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-green-700 mb-4 flex items-center gap-3">
            <FileText className="w-6 h-6" />
            Préambule
          </h2>
          <p className="text-slate-700 leading-relaxed">
            La présente charte encadre les partenariats conclus par la FTPE Outremer,
            dans le respect de son rôle syndical et de ses valeurs.
          </p>
        </section>

        {/* Principes */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-green-700 mb-4">Principes du partenariat</h2>
          <div className="grid md:grid-cols-2 gap-4">
            {principes.map((principe, index) => (
              <div key={index} className="flex items-center gap-3 p-4 bg-green-50 rounded-xl border border-green-200">
                <principe.icon className="w-5 h-5 text-green-700" />
                <p className="text-slate-700 font-medium">{principe.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Engagements */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-green-700 mb-4">Engagements du partenaire</h2>
          <div className="bg-slate-50 p-6 rounded-xl border-l-4 border-amber-500">
            <p className="text-slate-700 leading-relaxed">
              Le partenaire agit sous sa seule responsabilité et respecte les cadres
              juridiques applicables à ses activités. Il s'engage à ne pas utiliser
              le nom ou l'image de la FTPE Outremer à des fins commerciales sans
              autorisation préalable.
            </p>
          </div>
        </section>

        {/* Acceptation */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-green-700 mb-4">Acceptation</h2>
          <div className="bg-gradient-to-r from-green-50 to-amber-50 p-6 rounded-xl border border-green-200">
            <div className="flex items-start gap-3">
              <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
              <p className="text-slate-700 leading-relaxed">
                Toute collaboration avec la FTPE Outremer vaut acceptation pleine et entière
                de la présente charte. Le non-respect de ces principes peut entraîner
                la suspension ou la résiliation du partenariat.
              </p>
            </div>
          </div>
        </section>
      </div>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8 text-center">
        <p className="font-semibold">FTPE Outremer – Syndicat patronal ultramarin</p>
        <p className="text-slate-400 text-sm mt-2">Indépendance • Transparence • Responsabilité</p>
      </footer>
    </div>
  );
}
